module.exports = __webpack_public_path__ + "media/components/journeys/route-icons/Road-33fd614398364bad373fad00cea96d50.png";